module.exports = __webpack_public_path__ + "media/icons/naped-tyl-white-969ec2fe.png";